import React from "react";

const SEO = () => {
  return <h1>EXAM MODE</h1>;
};

export default SEO;